export * from './lib/display-relation-property.module';

export * from './lib/display-relation-property.component';
